import { Device } from "@/services/features/DeviceService";

export type Coordinates = { latitude: number; longitude: number };

const numberValue = (value: unknown): number | null => {
  const parsed =
    typeof value === "number" ? value : typeof value === "string" ? Number(value) : NaN;
  return Number.isFinite(parsed) ? parsed : null;
};

/** Converts legacy API coordinate payloads into the one shape used by Command Center UI. */
export const normalizeCoordinates = (value: unknown): Coordinates | null => {
  const record =
    value && typeof value === "object" && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null;
  const geoPoint =
    record?.geoPoint && typeof record.geoPoint === "object"
      ? (record.geoPoint as Record<string, unknown>)
      : record;
  const coordinates = geoPoint?.coordinates ?? record?.coordinates;
  const latitude = numberValue(
    geoPoint?.latitude ??
      geoPoint?.lat ??
      (Array.isArray(coordinates) ? coordinates[1] : undefined),
  );
  const longitude = numberValue(
    geoPoint?.lon ??
      geoPoint?.longitude ??
      geoPoint?.lng ??
      (Array.isArray(coordinates) ? coordinates[0] : undefined),
  );
  return latitude !== null &&
    longitude !== null &&
    Math.abs(latitude) <= 90 &&
    Math.abs(longitude) <= 180
    ? { latitude, longitude }
    : null;
};
export type DeviceStatus = "online" | "warning" | "offline" | "escalated";
export type DeviceKind = "SHOPPER" | "DOOR" | "ASSIST" | "ASSOCIATE" | "SURFACE" | "CENTRAL";
export type DeviceHealth = Record<DeviceStatus | "total" | "lowBattery", number>;
export type StoreHealth = {
  byType: Record<DeviceKind, DeviceHealth>;
  total: DeviceHealth;
  hasRecentAssociateActivity: boolean;
};
export type StoreHealthCache = {
  state: "queued" | "loading" | "complete" | "error";
  completedAt?: number;
  devices?: Device[];
  ignoredDevices?: Device[];
  health?: StoreHealth;
  error?: string;
};
